{
  "aNotificationWillBeSendToToAllLinkedPhoneNumbersWhenAnyOfTheseStateChangesOccurs": "Se enviará una notificación a todos los números de teléfono vinculados cuando ocurra cualquiera de estos cambios de estado...",
  "aboutCustomNotifications": "Acerca de las notificaciones personalizadas",
  "addYourPhoneNumber": "Añade tu número de teléfono",
  "changesFrom": "cambios de:",
  "createNotificationHelpBodyText": "De forma predeterminada, FarmHQ intentará notificar a todos los miembros de su cuenta de granja cuando suceda algo importante.\n\nSi desea recibir notificaciones personalizadas para dispositivos específicos, puede establecer reglas de notificación aquí.\n\nFarmHQ puede notificarle cuando un sensor de su dispositivo cambia de un estado a otro. Asegúrese de que los usuarios de su cuenta de granja hayan verificado sus números de teléfono en la configuración de su cuenta.\n\nDebe tener permiso para administrar notificaciones personalizadas para crear o eliminar reglas de notificación.",
  "deleteThisRule": "¿Eliminar esta regla?",
  "errorMessageAlreadyCreated": "Esta regla ya existe para este dispositivo.",
  "newNotificationRule": "Nueva regla de notificación",
  "newRule": "Nueva regla",
  "noCustomNotificationRulesHaveBeenCreatedForThisDevice": "No se han creado reglas de notificación personalizadas para este dispositivo.",
  "noVerifiedPhoneNumbersMessage": "No tienes números de teléfono verificados.\nPuedes registrar y verificar números de teléfono en el menú de configuración de tu cuenta.",
  "noVerifiedPhoneNumbersTitle": "No hay números de teléfono verificados",
  "notificationRules": "Reglas de notificación",
  "notifications": "Notificaciones",
  "notificationsDisabled": "Notificaciones deshabilitadas",
  "notificationsEnabled": "Notificaciones habilitadas",
  "sendANotificationToAllPhoneNumbersWhenThisStateChangeHappens": "Enviar una notificación a todos los números de teléfono cuando ocurra este cambio de estado...",
  "sendANotificationWhen": "Enviar una notificación cuando...",
  "autoMutedExplanation": "Este dispositivo fue silenciado automáticamente porque estaba enviando demasiadas notificaciones. Puedes activarlo de nuevo para reanudar la recepción de notificaciones.",
  "deviceMuted": "Dispositivo silenciado",
  "deviceMutedBanner": "Todas las notificaciones de este dispositivo están actualmente silenciadas.",
  "muteDevice": "Silenciar dispositivo",
  "unmute": "Activar sonido",
  "notificationChannel": "Canal de notificación",
  "notificationChannelDescription": "Elige cómo recibir las notificaciones de tus dispositivos.",
  "channelSms": "Solo SMS",
  "channelPush": "Solo push",
  "channelBoth": "SMS y push",
  "channelNone": "Ninguna",
  "channelPreferenceUpdated": "Preferencia de canal de notificación actualizada.",
  "notificationMode": "Modo de notificación",
  "notificationModeEnabled": "Habilitado",
  "notificationModeSuppressed": "Suprimido",
  "notificationPreferences": "Notification Preferences",
  "managePhoneNumbers": "Manage Phone Numbers",
  "manageNotificationsByDevice": "Manage Notifications by Device",
  "viewNotificationMap": "View on Map",
  "notificationMapTitle": "Notification Map",
  "legendEnabled": "Activo",
  "legendSuppressed": "Silenciado para mí",
  "legendMuted": "Silenciado para todos",
  "noDevicesMessage": "No devices found.",
  "personalPreferencesOnly": "These preferences apply only to your account.",
  "manageDevicesDescription": "These settings only affect your notifications. Other users' preferences are not changed.",
  "affectsOnlyYou": "This setting affects only your notifications.",
  "muteForAllUsers": "Mute for All Users",
  "muteForAllUsersDescription": "When muted, no users will receive notifications from this device.",
  "mutedByUserAt": "Muted by {{email}} on {{date}}.",
  "autoMutedAt": "Automatically muted on {{date}} due to excessive notifications.",
  "notificationSettings": "Notification Settings",
  "muteForMe": "Mute for Me",
  "muteForMeDescription": "Mute notifications from this device for your account only.",
  "mutedForMe": "Muted for you",
  "unmutedForMe": "Unmuted for you",
  "deviceMuteStatus": "Device Mute",
  "stateEnabled": "Habilitado",
  "stateMutedForMe": "Silenciado para mi",
  "stateMutedForAll": "Silenciado para todos",
  "disabledByAdmin": "Notificaciones deshabilitadas por un administrador.",
  "sendTestNotification": "Enviar notificación de prueba",
  "sendTestNotificationQuestion": "¿Enviar una notificación de prueba?",
  "sendTestToMe": "Enviarme una prueba",
  "sendTestToFarm": "Enviar prueba a todos",
  "testNotificationDescription": "Envíese una prueba para confirmar que las notificaciones funcionan, o pruebe con todos los usuarios de su granja.",
  "testNotificationFarmWarning": "Todos los usuarios de esta granja recibirán esta notificación de prueba, según su propia configuración de notificaciones.",
  "testNotificationDeviceWarning": "Todos los usuarios configurados para recibir notificaciones de este dispositivo recibirán esta notificación de prueba.",
  "testNotificationSent_one": "Notificación de prueba enviada a {{count}} destinatario.",
  "testNotificationSent_other": "Notificación de prueba enviada a {{count}} destinatarios.",
  "testNotificationPermissionRequired": "Necesita permiso para administrar las notificaciones de dispositivos para probar con todos los usuarios de su granja."
}
